import { render, staticRenderFns } from "./GerarSaques.vue?vue&type=template&id=446c3a96&"
import script from "./GerarSaques.vue?vue&type=script&lang=ts&"
export * from "./GerarSaques.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports